module.exports = __webpack_public_path__ + "static/media/galerija_2021 (9)-min.93ddca5d.jpg";